<h2 mat-dialog-title>Adicionar Comunicado</h2>
<mat-dialog-content>
  <form [formGroup]="form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Título</mat-label>
      <input matInput formControlName="title" required>
      @if (form.get('title')?.hasError('required')) {
        <mat-error>
          Título é obrigatório
        </mat-error>
      }
      @if (form.get('title')?.hasError('maxlength')) {
        <mat-error>
          Título deve ter no máximo 100 caracteres
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Corpo</mat-label>
      <textarea matInput formControlName="body" required rows="10"></textarea>
      @if (form.get('body')?.hasError('required')) {
        <mat-error>
          Corpo é obrigatório
        </mat-error>
      }
      @if (form.get('body')?.hasError('maxlength')) {
        <mat-error>
          Corpo deve ter no máximo 10000 caracteres
        </mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancelar</button>
  <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!form.valid">
    Criar
  </button>
</mat-dialog-actions>
